const answer = `The largest known star in the Milky Way by physical volume is Stephenson 2-18 (also known as Stephenson 2 DFK 1). It is an extreme red supergiant located about 19,000 light-years away from Earth.

Mind-Boggling Dimensions

Radius: Roughly 2,150 times that of our Sun.
Solar System Scale: If placed at the center of our solar system, its edge would extend past the orbit of Saturn.
Volume: It could hold about 10 billion Suns inside it.

Other Contenders and Measuring Challenges

Determining the exact boundaries of these cosmic giants is incredibly difficult. Because they are old, unstable, and have highly diffuse edges (gaseous surfaces that fade slowly into space), astronomers often debate their true sizes. As a result, several other massive stars frequently trade places at the top of the list depending on new measurements:

UY Scuti: Long considered the record holder, this red hypergiant measures approximately 1,700 solar radii. If it replaced the Sun, it would easily swallow everything out to Jupiter.
VY Canis Majoris: A highly active red hypergiant with an estimated radius of 1,420 solar radii.

Size vs. Weight (Mass)

It is important to note that "largest" refers to volume (physical size), not weight. Despite its immense size, Stephenson 2-18 has a very low density. The title for the heaviest (most massive) known star belongs to a completely different type of star altogether, R136a1, which is located in a neighboring galaxy and weighs roughly 250 to 300 times more than our Sun.

If you are curious about extreme stars, would you like to know more about how Stephenson 2-18 compares to Betelgeuse, or how the heaviest stars in the universe differ from the largest?`;

const response = {
  query: "largest star in the milky way",
  url: "https://www.google.com/search?q=largest+star+in+the+milky+way&udm=50",
  answer,
  sources: [
    { title: "List of largest stars - Wikipedia", url: "https://en.wikipedia.org/wiki/List_of_largest_stars", domain: "en.wikipedia.org", snippet: "" },
    { title: "The largest known star : r/Astronomy - Reddit", url: "https://www.reddit.com/r/Astronomy/comments/1fwr4ax/the_largest_known_star/", domain: "reddit.com", snippet: "" },
    { title: "What is the biggest star in the universe? - Space", url: "https://www.space.com/41290-biggest-star.html", domain: "space.com", snippet: "" },
    { title: "The Ten Biggest Stars In The Milky Way - World Atlas", url: "https://www.worldatlas.com/space/the-ten-biggest-stars-in-the-milky-way.html", domain: "worldatlas.com", snippet: "" },
    { title: "The 8 Biggest Stars in the Milky Way Galaxy - Nayak's Tutorials", url: "https://nayakstutorials.com/blog/the-8-biggest-stars-in-the-milky-way-galaxy", domain: "nayakstutorials.com", snippet: "" },
    { title: "UY Scuti - Wikipedia", url: "https://en.wikipedia.org/wiki/UY_Scuti", domain: "en.wikipedia.org", snippet: "" },
    { title: "Biggest monster star! And the heaviest stars", url: "https://earthsky.org/space/how-big-is-the-biggest-monster-star/", domain: "earthsky.org", snippet: "" }
  ],
  related_queries: []
};

export const async_google_ai_mode = {
  input: "largest star in the milky way",
  result: JSON.stringify(response, null, 2)
};
